module.exports = __webpack_public_path__ + "8b93bfabc49e1eb085905f431d72f86c.svg";